module.exports = __webpack_public_path__ + "media/torsten4.d666f92b.mp3";